import { STATUSES } from '../../utils/Statuses';
import * as Yup from 'yup';


export const subscriptionHubTabs = [
  {
    id: 1,
    title: 'Plan Management',
    active: true,
    status: 1,
  },
  {
    id: 2,
    title: 'Transactions',
    active: false,
    status: 2,
  },
];
export const TwoFactor = {
APP:'APP',
SMS:'SMS'
}

export const childCompanies = [
  {
    id: 1,
    title: 'Active',
    active: true,
    status: STATUSES.LIVE,
  },
  {
    id: 2,
    title: `Inactive`,
    active: false,
    status: STATUSES.INACTIVE,
  },
  {
    id: 3,
    title: `Pending`,
    active: false,
    status: STATUSES.PENDING,
  },
  {
    id: 4,
    title: `Suspended`,
    active: false,
    status: STATUSES.SUSPENDED,
  },
];


export const customeCompnayAddressValidation={
  saveAddress: Yup.boolean(),
  // town: Yup.string().required('Required'),
  postcode: Yup.string().required('Required'),
  country: Yup.string().required('Required'),
  address: Yup.string().required('Required'),
  title: Yup.string().required('Required'),
}


export const PRODUCT_TYPES_CUSTOM={
  INTERNAL:"INTERNAL",
  PRIVATE:"PRIVATE",
  ADVERTISING:"ADVERTISING",
  
  }

export const PRODUCT_TYPES={
AGENCY:"AGENCY",
CLIENT_APPLY_SOURCE:"CLIENT_APPLY_SOURCE"

}


const formatValidationError = (error) => {
  const errors = [];
  if (!error || typeof error !== 'object') {
    return errors;
  }

  if (error.constraints) {
    for (const constraintKey in error.constraints) {
      if (error.constraints[constraintKey]) {
        errors.push(`${error.property}: ${error.constraints[constraintKey]}`);
      }
    }
  }

  if (error.children && error.children.length > 0) {
    error.children.forEach((child) => {
      errors.push(...formatValidationError(child));
    });
  }

  return errors;
};

export const processValidationErrors = (errorResponse) => {
  try {
    let errorMessages = [];
    // RTK Query payload is usually { status, data }; some callers pass `data` directly.
    const data = errorResponse?.data ?? errorResponse;

    if ((data?.message || data?.msg) && !data?.response) {
      return data?.message || data?.msg || '';
    }

    const errors = data?.response?.errors;
    if (Array.isArray(errors) && errors.length > 0) {
      errors.forEach((error) => {
        errorMessages.push(...formatValidationError(error));
      });
    }

    return errorMessages.length > 0 ? errorMessages.join(', ') : '';
  } catch {
    // Never let error-formatting itself become an unhandled rejection (PostHog).
    return '';
  }
};